module.exports = __webpack_public_path__ + "static/image-05-ed5a9055d1f50a8a79cd138bdcde4560.jpg";